import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import { useAuthentication } from '../../hooks/useAuthentication'
// import PropTypes from 'prop-types'

// import { makeStyles } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Loader from '../Loader'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import { useMutation } from '@apollo/react-hooks'
import { GET_VOUCHERS, DELETE_VOUCHERS } from './gql'
import Alert from '@mui/material/Alert'

const List = () => {
  const { authState } = useAuthentication();
  const vouchers = useQuery(GET_VOUCHERS, {
    context: { headers: { authorization: authState.authToken } },
  })
  const [deleteVoucher, deleteVoucherResp] = useMutation(DELETE_VOUCHERS);
  const location = useLocation();

  useEffect(() => {
    vouchers.refetch()
  }, []);

  useEffect(() => {
    if (deleteVoucherResp.data) {
      vouchers.refetch()
    }
  }, [deleteVoucherResp.data, vouchers])

  if (vouchers.loading) return <Loader />;
  if (vouchers.error) return <p>ERROR</p>;

  const removeVoucher = (id) => {
    deleteVoucher({ variables: { id } })
  }

  return (
    <>
      {deleteVoucherResp.data && (
        <>
          <br />
          <Alert variant="outlined" severity="success">
            Voucher deleted Successfully.
          </Alert>
        </>
      )}
      {location.state && location.state.message && (
        <>
          <br />
          <Alert variant="outlined" severity="success">
            {location.state.message}
          </Alert>
        </>
      )}
      <Paper square elevation={0}>
        <Toolbar>
          <Typography variant="h6" component="div">
            Vouchers
          </Typography>
          <Box flexGrow="1" />
        </Toolbar>
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Ref#</TableCell>
                <TableCell>Department</TableCell>
                <TableCell width="10%">Date</TableCell>
                <TableCell>Prepared by</TableCell>
                {/* <TableCell>Claimed by</TableCell> */}
                <TableCell>Amount&nbsp;</TableCell>
                <TableCell>Paid</TableCell>
                <TableCell>Pay to</TableCell>
                <TableCell>Status</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vouchers.data.vouchers.map((voucher) => (
                <TableRow key={voucher.id}>
                  <TableCell component="th" scope="row">
                    <Link to={`/panel/vouchers/${voucher.id}/edit`}>
                      {voucher.reference_number}
                    </Link>
                  </TableCell>
                  <TableCell>{voucher.department.name}</TableCell>
                  <TableCell>
                    {
                      new Date(voucher.created_at * 1)
                        .toISOString()
                        .split('T')[0]
                    }
                  </TableCell>
                  <TableCell>
                    {voucher.created_by.first_name}{' '}
                    {voucher.created_by.last_name}
                  </TableCell>
                  {/* <TableCell>
                  {voucher.claimed_by.first_name} {voucher.claimed_by.last_name}
                </TableCell> */}
                  <TableCell>{voucher.total_amount}</TableCell>
                  <TableCell>{voucher.paid_by_amin ? 'Yes' : 'No'}</TableCell>
                  <TableCell>
                    {voucher.pay_to.first_name} {voucher.pay_to.last_name}
                  </TableCell>
                  {/* <TableCell>
                  {voucher.voucher_cost_category.map((c) => (
                    <Box
                      key={c.cost_category.code}
                      component="span"
                    >{`${c.cost_category.name} (${c.cost_category.code}), `}</Box>
                  ))}
                </TableCell> */}
                  <TableCell>{voucher.state}</TableCell>

                  <TableCell>
                    {voucher.state === 'DRAFT' && (
                      <Button>
                        <DeleteIcon
                          onClick={() => {
                            if (window.confirm('Are you sure')) {
                              removeVoucher(voucher.id)
                            }
                          }}
                        />
                      </Button>
                      )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  )
}

export default List
